export default __webpack_public_path__ + "static/media/l.8622f772.jpg";